import React from "react"
import PropTypes from "prop-types"
import _filter from "lodash/filter"
import _get from "lodash/get"
import isNil from "ramda/src/isNil"
import { connect } from "react-redux"

import Content from "./Content"
import AudioContent from "./AudioContent"
import ContentWorkList from "./ContentWorkList"

import {
  canShowStages,
  objectConstructor
} from "../../incident-manager-helpers"
import { useAudioDemandFile } from "../utils/useAudioDemandFile"

import styles from "./styles.css"

const constructorInfos = ({ demand, t }) => {
  const {
    productType,
    protocolNumber,
    createdDate,
    qualifyTypeDescription,
    closeDate,
    requestStatus,
    serviceOrder,
    summary,
    invoice,
    invoiceDate,
    invoiceValue,
    selectedReason,
    disputingData
  } = demand

  const general = _filter(
    [
      objectConstructor("Tipo", productType),
      objectConstructor(t("MSG_0249"), protocolNumber),
      objectConstructor(t("MSG_0239"), qualifyTypeDescription),
      objectConstructor(t("MSG_0242"), createdDate),
      objectConstructor(t("MSG_0240"), closeDate),
      objectConstructor(t("MSG_0052"), requestStatus)
    ],
    (info) => !isNil(info.value) && !!info.value
  )

  const summaryInfo = summary
    ? objectConstructor(t("DEMAND_SUMMARY"), summary)
    : null

  const invoiceDispute = _filter(
    [
      objectConstructor(t("MSG_0029"), invoice),
      objectConstructor(t("INVOICE_EXPIRATION"), invoiceDate),
      objectConstructor(t("VALUE_INVOICE"), invoiceValue),
      objectConstructor(t("INVOICE_DISPUTING_STEP_4_B"), selectedReason),
      {
        ...objectConstructor(t("INVOICE_DISPUTING_STEP_5"), disputingData),
        direction: "col"
      }
    ],
    (info) => !isNil(info.value) && !!info.value
  )

  const closingCode = _get(serviceOrder, "closingCode")
  const serviceOrderInfo = closingCode
    ? objectConstructor(t("MSG_0373"), closingCode)
    : null

  return {
    general,
    summary: summaryInfo,
    invoiceDispute,
    serviceOrder: serviceOrderInfo
  }
}

const ContentDemand = ({
  useAudioDemandFile,
  demand,
  customerDemands,
  t,
  innerRef
}) => {
  const { general, summary, invoiceDispute, serviceOrder } = constructorInfos({
    demand,
    t
  })

  const stateAudio = useAudioDemandFile(demand)
  innerRef.current = stateAudio.audioBase64

  return (
    <div className={styles.content}>
      <Content infos={general} isList />
      <Content infos={summary} />
      <Content infos={invoiceDispute} isList />
      <AudioContent {...stateAudio} demand={demand} />
      <Content infos={serviceOrder} />
      {canShowStages(demand) && (
        <ContentWorkList t={t} worklist={customerDemands.reverse()} />
      )}
    </div>
  )
}

ContentDemand.propTypes = {
  demand: PropTypes.object,
  customerDemands: PropTypes.array,
  useAudioDemandFile: PropTypes.string,
  t: PropTypes.func,
  innerRef: PropTypes.object
}

export default connect(
  null,
  {
    useAudioDemandFile
  },
  null,
  { forwardRef: true }
)(ContentDemand)



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/RequestTrackingModal/ContentDemand.js